/**
 * Lesson
 */

export default class NextLesson {
  id: string;
  title: string;
  subTitle: string;
  coverArtUrl: string;

  constructor({ id, title, subTitle, coverArtUrl}: NextLesson) {
    Object.assign(this, { id, title, subTitle, coverArtUrl });
  }
}